<template>
    <div :class="['modal-container', { 'active': active },]" style="max-width: 100%;">
        <div class="card head-card news">
            <div class="title-card">
                <h4>Elegir Medios</h4>
                <button class="touchpad" @click="cancelar">x</button>
            </div>
            <div class="card-content">
                <div class="row">
                    <div class="col-12 " v-if="permisOfline">
                        <div class="title-card">
                            <h4>Offline</h4>

                        </div>
                        <div class="card-content">
                            <div class="checkbox" v-if="permisos.indexOf('T') >= 0">
                                <label for="tv">
                                    <span class="btn-icon">
                                        <svg fill="#02B99E" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20px"
                                            height="20px" viewBox="0 0 24 24">
                                            <path
                                                d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="tv" value :checked="television"
                                        @click="seleccionarMedio('T', $event)" />
                                    Programas de televisión
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <div class="checkbox" v-if="permisos.indexOf('R') >= 0">
                                <label for="radio">
                                    <span class="btn-icon">
                                        <svg fill="#02B99E" xmlns="http://www.w3.org/2000/svg" height="20px" width="20px"
                                            viewBox="0 0 24 24">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z" />
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="radio" value :checked="radioP"
                                        @click="seleccionarMedio('R', $event)" />
                                    Programas de radio
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-1">
                        <div class="title-card">
                            <h4>Online</h4>

                        </div>
                        <div class="card-content">
                            <div class="checkbox iconed" v-if="permisos.indexOf('PD') >= 0">
                                <label for="news">
                                    <span class="btn-icon">
                                        <svg fill="#02B99E" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 576 512">
                                            <path
                                                d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z" />
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="news" value :checked="portalNoti"
                                        @click="seleccionarMedio('PD', $event)" />
                                    Portales de noticias
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <div class="checkbox iconed" v-if="permisos.indexOf('TW') >= 0">
                                <label for="cbox-twitter">
                                    <span class="btn-icon">
                                        <svg viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" transform="translate(-304.98 -380.994)" fill="#00b99e"/>
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="cbox-twitter" value="" :checked="twitter"
                                        @click="seleccionarMedio('TW', $event)">
                                    X
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <div class="checkbox iconed" v-if="permisos.indexOf('FB') >= 0">
                                <label for="cbox-fb">
                                    <span class="btn-icon">
                                        <svg width="10" height="21" viewBox="0 0 10 21">
                                            <g id="Objeto_inteligente_vectorial" data-name="Objeto inteligente vectorial"
                                                transform="translate(-46 -836)">
                                                <g id="Objeto_inteligente_vectorial-2"
                                                    data-name="Objeto inteligente vectorial"
                                                    transform="translate(14.972 808.093)">
                                                    <path id="Trazado_309" data-name="Trazado 309"
                                                        d="M37.629,34.2V32.51a.891.891,0,0,1,.94-1h2.4v-3.6H37.664a4.116,4.116,0,0,0-4.5,4.4V34.2H31.028v4.2h2.157V48.907h4.281V38.4h3.167l.139-1.652.255-2.552Z"
                                                        fill="#262626" fill-rule="evenodd" />
                                                </g>
                                                <path id="Color_Overlay" data-name="Color Overlay"
                                                    d="M48.157,857V846.494H46v-4.2h2.135V840.4a4.115,4.115,0,0,1,4.5-4.4h3.307v3.6h-2.4a.892.892,0,0,0-.94,1v1.686H56l-.255,2.552-.139,1.652H52.438V857Z"
                                                    fill="#00b99e" />
                                            </g>
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="cbox-fb" value="" :checked="facebook"
                                        @click="seleccionarMedio('FB', $event)">
                                    Facebook
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <div class="checkbox iconed" v-if="permisos.indexOf('Y') >= 0">
                                <label for="cbox-youtube">
                                    <span class="btn-icon">
                                        <svg width="21" height="15" viewBox="0 0 21 15">
                                            <image id="youtube" width="21" height="15"
                                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAPCAYAAAALWoRrAAAABHNCSVQICAgIfAhkiAAAARFJREFUOI2t1L0uREEYxvHfGRKFr1Wo2I5OiE5JJKdyEyehWImLcAuiQMRW7kBjE4VSJUIjUfkoBYtChFGclUiw52yy//p5/5PMzPMmMUZJoz6LFUxiDP0YRg8G/KaJTzzhGbe4wm5Ms7PE4d4MTtD3x3CnvGEuoNYloZanFjDVJeE30wHVgtAR7juQVgMqBaED+QNu4qOEtBIwVJSKafYQ02wNszguiPeHEif/lJ/HNJvHfrtcbyfSpFGfwgYWiqRNBVeQNOojWMeqvBDtaAZ5K9qxhEuslRDCY8B1QWgRoyVk39wEXHQwUIaLgC15Z7vBO7aT1paawTImMI5B+Zb67x+/yIvwhFfcybfUTkyz0y8F4EEEvvlVdQAAAABJRU5ErkJggg==" />
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="cbox-youtube" value="" :checked="youtube"
                                        @click="seleccionarMedio('Y', $event)">
                                    Youtube
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <div class="checkbox iconed" v-if="permisos.indexOf('TK') >= 0">
                                <label for="cbox-tiktok">
                                    <span class="btn-icon">
                                        <svg  xmlns="http://www.w3.org/2000/svg" width="20px"
                                            height="20px" viewBox="0 0 32 32">
                                            <path
                                                d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
                                        </svg>
                                    </span>
                                    <input class="box" type="checkbox" id="cbox-tiktok" value="" :checked="tiktok"
                                        @click="seleccionarMedio('TK', $event)">
                                    Tiktok
                                    <span class="nbox">
                                        <svg viewBox="0 0 14.018 13.003">
                                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                transform="translate(-304.98 -380.994)" fill="#fff" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-1">
                        <button class="button fluid" @click="guardarw">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['active', 'cancelar', 'guardar', 'error', 'permisos', 'slMedios'],
    data() {
        return {
            permisOfline: false,
            permisOnline: false,


            fi: {},
            fiParams: {},
            medioSelect: [],

        }
    },
    computed: {
        // "T", "R", "PD", "FB", "TW", "Y", "I"
        twitter() {
            return this.medioSelect.includes('TW');
        },
        facebook() {
            return this.medioSelect.includes('FB');
        },
        youtube() {
            return this.medioSelect.includes('Y');
        },
        portalNoti() { return this.medioSelect.includes('PD'); },
        television() { return this.medioSelect.includes('T'); },
        radioP() { return this.medioSelect.includes('R'); },
        tiktok() { return this.medioSelect.includes('TK'); },
    },
    mounted() {
        this.permisOnline = this.validar_permisos('online');
        this.permisOfline = this.validar_permisos('ofline');

        console.log("aqui==>medios", this.slMedios);
        this.medioSelect = this.slMedios;

        console.log("aqui==>medios", this.medioSelect);
    },
    beforeMount() {
        this.medioSelect = this.slMedios;
    },
    methods: {
        validar_permisos(medioPs) {
            if (medioPs == "online") {
                return this.permisos.indexOf('PD') || this.permisos.indexOf('FB') || this.permisos.indexOf('TW') || this.permisos.indexOf('Y') || this.permisos.indexOf('I') || this.permisos.indexOf('TK');
            }
            if (medioPs == 'ofline') {
                return this.permisos.indexOf('T') || this.permisos.indexOf('R');
            }
            return false;
        },
        seleccionarMedio(sl, event) {
            if (event.target.checked == true) {
                if (!this.medioSelect.includes(sl)) {
                    this.medioSelect.push(sl);
                }
            } else {
                var indice = this.medioSelect.findIndex(function (objeto) {
                    return objeto === sl;
                });
                if (indice > -1) {
                    this.medioSelect.splice(indice, 1);
                }

            }
            console.log(this.medioSelect);
        },

        guardarw() {
            this.guardar(this.medioSelect);
        }
    },

}
</script>